import { render, staticRenderFns } from "./UsersListDisplay.vue?vue&type=template&id=3f6b79a0&scoped=true"
import script from "./UsersListDisplay.vue?vue&type=script&lang=js"
export * from "./UsersListDisplay.vue?vue&type=script&lang=js"
import style0 from "./UsersListDisplay.vue?vue&type=style&index=0&id=3f6b79a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6b79a0",
  null
  
)

export default component.exports